<template>
  <div>
    <div class="title-bar clearfix">
      <div class="module pull-left">
        {{$t("qrc.title")}}
      </div>
      <div class="btn-group pull-right">
        <el-button class="sm-hidden" v-if="canEdit" :plain="true" size="mini" @click="generateDialogVisible=true">{{ $t("qrc.generateCode") }}
          <i class="fa fa-qrcode"></i>
        </el-button>
        <el-button class="sm-hidden" :plain="true" size="mini" @click="QRCHistory">{{ $t("qrc.history") }}
          <i class="fa fa-history"></i>
        </el-button>
        <el-button v-if="canEdit" :plain="true" size="mini" @click="statusDialogVisible=true">{{ $t("qrc.setCodeStatus") }}
          <i class="fa fa-cog"></i>
        </el-button>
        <el-button :plain="true" size="mini" @click="refresh">{{ $t("refresh") }}
          <i class="fa fa-refresh"></i>
        </el-button>
        <el-button :plain="true" size="mini" @click="searchDialogVisible=true">{{ $t("search") }}
          <i class="fa fa-search"></i>
        </el-button>
      </div>
    </div>
    <div class="data-list" v-loading="loading" element-loading-text="Loading">
      <el-table border stripe :data="codes" size="mini" class="customer-table">
        <el-table-column prop="QRCode1" align="center" :resizable="true" :label="this.$t('qrc.qrcode1')">
        </el-table-column>
        <el-table-column prop="QRCode2" align="center" :resizable="true" :label="this.$t('qrc.qrcode2')">
        </el-table-column>
        <el-table-column prop="BatchNumber" align="center" :resizable="true" :label="this.$t('qrc.batchNumber')">
        </el-table-column>
        <el-table-column prop="Status" align="center" width="120px" :resizable="true" :label="this.$t('qrc.status')">
          <template slot-scope="scope">
            <el-tag :type="tagType(scope.row.Status)">
              {{statusFormatter(scope.row.Status)}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="GeneratedTime" align="center" :resizable="true" :label="this.$t('qrc.generateTime')" :formatter="timeFormatter">
        </el-table-column>
      </el-table>

      <el-row class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[15, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </el-row>

      <!-- search dialog -->
      <el-dialog class="search-dialog" :title="this.$t('search')" :visible.sync="searchDialogVisible">
        <el-form class="search-form" :model="filter" :inline="true" size="small" label-width="70px">
          <el-form-item :label="this.$t('qrc.qrcode1')" size="small">
            <el-input v-model="filter.QRCode1"></el-input>
          </el-form-item>
          <el-form-item :label="this.$t('qrc.qrcode2')" size="small">
            <el-input v-model="filter.QRCode2"></el-input>
          </el-form-item>

          <el-form-item :label="this.$t('qrc.generateTime')" size="small">
            <el-date-picker v-model="filter.StartGenTime" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item :label="this.$t('to')" size="small">
            <el-date-picker v-model="filter.EndGenTime" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item :label="this.$t('qrc.status')" prop="Status">
            <el-select v-model="filter.Status" size="small" :clearable="true">
              <el-option v-for="(val,key) in statusList" :key="key" :label="$t(`qrc.statusEnum.${key}`)" :value="val">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="this.$t('qrc.batchNumber')" size="small">
            <el-input v-model="filter.BatchNumber"></el-input>
          </el-form-item>
        </el-form>

        <div slot="footer" class="search-footer">
          <el-button @click="searchDialogVisible = false" :plain="true" size="mini">{{this.$t('cancel')}}</el-button>
          <el-button @click="resetFilter" :plain="true" size="mini">{{this.$t('reset')}}</el-button>
          <el-button type="primary" @click="search" :plain="true" size="mini">{{this.$t('confirm')}}</el-button>
        </div>
      </el-dialog>

      <!-- qrcode generate dialog -->
      <el-dialog class="search-dialog" :title="this.$t('qrc.generateCode')" :visible.sync="generateDialogVisible" width="400px">
        <el-form class="search-form" size="small" :inline="true" label-width="100px">
          <el-form-item :label="this.$t('qrc.codeCount')" size="small">
            <el-select v-model="generateCount">
              <el-option v-for="c in genCountList" :key="c" :label="c" :value="c">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="search-footer">
          <el-button @click="generateDialogVisible = false" :plain="true" size="mini">{{this.$t('cancel')}}</el-button>
          <el-button type="primary" @click="generateCode" :plain="true" size="mini" :loading="generating">{{this.$t('qrc.generate')}}</el-button>
        </div>
      </el-dialog>

      <!-- qrcode status dialog -->
      <el-dialog class="search-dialog" :title="this.$t('qrc.setCodeStatus')" :visible.sync="statusDialogVisible" width="460px">
        <el-form id="status-dialog" class="search-form" size="small" status-icon ref="statusForm" :model="setStatusInfo" :inline="true" :rules="setStatusInfo.rules" label-width="70px">
          <el-form-item :label="this.$t('qrc.batchNumber')" size="small" prop="batchNumber">
            <el-input v-model="setStatusInfo.batchNumber"></el-input>
          </el-form-item>

          <el-form-item :label="this.$t('qrc.status')" prop="status">
            <el-select v-model="setStatusInfo.status" size="small">
              <el-option v-for="(val,key) in changeStatusList" :key="key" :label="$t(`qrc.statusEnum.${key}`)" :value="val">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="search-footer">
          <el-button @click="statusDialogVisible = false" :plain="true" size="mini">{{this.$t('cancel')}}</el-button>
          <el-button type="primary" @click="setCodeStatus" :plain="true" size="mini">{{this.$t('setup')}}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import statusList from "./status";
import changeStatusList from "./changeStatus";
import roleTypes from "../../../models/roleTypes";
import searchTypes from "../../../models/searchTypes";
import searchHistoryService from "../../../services/searchHistoryService";
import fileSaver from "file-saver";
import { mapGetters } from "vuex";
export default {
  name: "QRCCode",
  data() {
    var checkBatchNumber = (r, v, callback) => {
      if (v) {
        this.$axios.get(`api/qrc/existBatchNumber/${v}`).then(resp => {
          if (resp.data) {
            callback();
          } else {
            callback(new Error(this.$t("qrc.batchNumberNotExist")));
          }
        });
      }
    };

    return {
      changeStatusList: changeStatusList,
      statusList: statusList,
      searchDialogVisible: false,
      generateDialogVisible: false,
      statusDialogVisible: false,
      pageSize: 15,
      pageIndex: 1,
      codes: [],
      totalCount: 0,
      loading: true,
      generating: false,
      generateCount: 1000,
      genCountList: [1000, 10000, 50000, 100000],
      filter: {
        QRCode1: "",
        QRCode2: "",
        Status: null,
        StartGenTime: null,
        EndGenTime: null,
        BatchNumber: ""
      },
      filterOptions: [],
      setStatusInfo: {
        status: 1,
        batchNumber: "",
        rules: {
          batchNumber: [
            {
              required: true,
              message: this.$t("qrc.batchNumberNotEmpty"),
              trigger: "blur"
            },
            { validator: checkBatchNumber, trigger: "blur" }
          ],
          status: [{ required: true, message: this.$t("qrc.plsSelectStatus") }]
        }
      }
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.getCodes();
      } else {
        this.pageIndex = 1;
      }
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getCodes();
    },
    getCodes() {
      this.loading = true;
      let params = {
        filter: JSON.stringify(this.filterOptions),
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$axios
        .get("api/qrc", { params })
        .then(res => {
          this.totalCount = res.data.TotalCount;
          this.codes = res.data.Data;
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        });
    },
    search() {
      this.searchDialogVisible = false;
      this.setFilterOptions();
      searchHistoryService.setHistory(
        searchTypes.QRC_HISTORY,
        this.filterOptions
      );
      this.getCodes();
    },
    resetFilter() {
      this.pageIndex = 1;
      this.filter = {};
      this.filterOptions = [];
      searchHistoryService.removeHistory(searchTypes.QRC_HISTORY);
    },
    setFilterOptions() {
      this.filterOptions = [];
      Object.keys(this.filter).forEach(k => {
        let val = this.filter[k];
        if (typeof val === "number" || val) {
          this.filterOptions.push({ name: k, value: val });
        }
      });
    },
    refresh() {
      this.resetFilter();
      this.getCodes();
    },
    statusFormatter(cellValue) {
      let key = Object.keys(this.statusList).filter(
        k => this.statusList[k] === cellValue
      );
      return this.$t(`qrc.statusEnum.${key}`);
    },
    initializeFilter() {
      let his = searchHistoryService.getHistory(searchTypes.QRC_HISTORY);
      if (his) {
        let keys = Object.keys(this.filter);
        his.forEach(h => {
          if (keys.includes(h.name)) {
            this.filter[h.name] = h.value;
          }
        });
        this.setFilterOptions();
      }
    },
    generateCode() {
      this.generating = true;
      this.$axios
        .get(`api/qrc/generate/${this.generateCount}`)
        .then(res => {
          let fileName = decodeURIComponent(
            res.headers["file-name"] || "二维码.csv"
          );
          const BOM = "\ufeff";
          let blob = new Blob([BOM + res.data]);
          fileSaver.saveAs(blob, fileName);
          this.getCodes();
          this.generating = false;
          this.generateDialogVisible = false;
        })
        .catch(e => {
          this.generating = false;
          this.getCodes();
        });
    },
    setCodeStatus() {
      this.$refs["statusForm"].validate(valid => {
        if (valid) {
          this.$axios
            .put("api/qrc/setstatus", {
              batchNumber: this.setStatusInfo.batchNumber,
              status: this.setStatusInfo.status
            })
            .then(resp => {
              this.$message({
                type: "success",
                message: this.$t("qrc.setStatusSuccess")
              });
              this.statusDialogVisible = false;
              this.getCodes();
            })
            .catch(e => {
              let msg =
                (e.response && e.response.data) || this.$t("qrc.setStatusFail");
              this.$message({
                type: "error",
                message: msg
              });
            });
        } else {
          return false;
        }
      });
    },
    QRCHistory() {
      this.$router.push({ name: "QRCHistory" });
    },
    tagType(status) {
      switch (status) {
        case 0:
          return "";
        case 1:
          return "success";
        case 2:
          return "warning";
        case 3:
          return "info";
        default:
          return "";
      }
    }
  },
  computed: {
    ...mapGetters(["roles", "permissions"]),
    canEdit() {
      return (
        this.roles.includes(roleTypes.Administrator) ||
        this.permissions.find(
          p =>
            p.toLowerCase() === "qrc.edit" || p.toLowerCase() === "qrc.insert"
        )
      );
    }
  },
  created() {
    this.initializeFilter();
    searchHistoryService.removeBesides(searchTypes.QRC_HISTORY);
    this.getCodes();
  }
};
</script>

<style lang="scss">
#status-dialog .el-input {
  width: 280px;
}
</style>









// WEBPACK FOOTER //
// src/components/application/QRC/QRCCode.vue